/**
 * A special Device ID value used to denote the current device.
 */
export const LOCAL_DEVICE_ID = '@local';
/**
 * The maximum volume value in the Connect protocol.
 *
 * To simplify the volume controls, we translate this value from 0 to 1.
 */
export const GAIA_VOLUME = 65535.0;
//# sourceMappingURL=typedefs.js.map